import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  RefreshBuyerActivitySummaryMutation,
  RefreshBuyerActivitySummaryMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";
import { updateBuyerActivityCache } from "./updateBuyerActivityCache";

const REFRESH_BUYER_ACTIVITY_MUTATION = graphql(`
  mutation refreshBuyerActivitySummary(
    $GenerateBuyerActivitySummaryRequest: GenerateBuyerActivitySummaryRequest!
  ) {
    refreshBuyerActivitySummary(
      GenerateBuyerActivitySummaryRequest: $GenerateBuyerActivitySummaryRequest
    ) {
      status
      updatedAt
      questions {
        question
        answer
        sources {
          type
          id
          url
          title
          chunkNumber
          documentType
          filePath
          isDeleted
          citationId
          locations {
            pageNumber
            bbox {
              x
              y
              width
              height
            }
          }
        }
      }
    }
  }
`);

export function useRefreshBuyerActivity(
  options?: UseMutationOptions<
    RefreshBuyerActivitySummaryMutation,
    unknown,
    RefreshBuyerActivitySummaryMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(REFRESH_BUYER_ACTIVITY_MUTATION, {
    ...options,
    onSuccess: async (data, variables, context) => {
      await updateBuyerActivityCache(
        queryClient,
        variables.GenerateBuyerActivitySummaryRequest.objectId,
        variables.GenerateBuyerActivitySummaryRequest.objectType,
        data.refreshBuyerActivitySummary,
      );
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error, variables, context) => {
      console.warn("Failed to refresh buyer activity", JSON.stringify(error));
      options?.onError?.(error, variables, context);
    },
  });

  return { data, ...rest };
}
